module.exports = __webpack_public_path__ + "media/images/manage-offer/puzzle_illustration-0793c61ad3b82d87660e6c20f105701a.svg";